import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';
import TableCell from 'components/TableCell';

import { PoiListRow_poi$key } from '__generated__/PoiListRow_poi.graphql';

type Props = EntityTableRowProps & {
  poi: PoiListRow_poi$key;
};

const PoiListRow: FC<Props> = ({ poi, ...props }) => {
  const poiData = useFragment(
    graphql`
      fragment PoiListRow_poi on Poi {
        id
        name

        ...EntityTableRow_entity
      }
    `,
    poi
  );

  const { id, name } = poiData;

  return (
    <EntityTableRow entity={poiData} {...props}>
      <TableCell>
        <Link href={id}>{name}</Link>
      </TableCell>
    </EntityTableRow>
  );
};

export default PoiListRow;
